import { render, staticRenderFns } from "./addComponents.vue?vue&type=template&id=1d561863&scoped=true&"
import script from "./addComponents.vue?vue&type=script&lang=js&"
export * from "./addComponents.vue?vue&type=script&lang=js&"
import style0 from "./addComponents.vue?vue&type=style&index=0&id=1d561863&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d561863",
  null
  
)

export default component.exports